// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recipe img{border-radius:15px}.prod-details-img-slider .slick-list,.prod-details-img-slider .slick-slide>div,.prod-details-img-slider.slick-slider,.prod-details-img-slider .slick-track{height:100%}.prod-details-img-slider .pro-img-wrap{height:100%;position:relative;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
